import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ActionButtonControl, ButtonControl} from '../../../models/uiArtefakt';
import {EventService} from '../../../services/event.service';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {EnumButtonAktionsTyp} from '../../../models/enumButtonAktionsTyp';
import {ButtonCommandService} from '../../../services/button-command.service';
import {UiUpdateService} from '../../../services/ui-update.service';

@Component({
    selector: 'lv-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    standalone: false
})
export class ActionButtonComponent implements OnInit, AfterViewInit {

public isDisabled: boolean = false;
public uiAusrichtung: UIAusrichtung;

private _uiArtefakt: ActionButtonControl;

  constructor(private _buttonCommandService: ButtonCommandService, private _uiUpdateService: UiUpdateService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): ActionButtonControl {
    return this._uiArtefakt;
  }

@Input() set uiArtefakt(uiArtefakt: ActionButtonControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnInit(): void {
  }

public onButtonClicked() {
  this._buttonCommandService.handleActionButtonAktionstyp(this._uiArtefakt.ButtonAktionsTyp)
      .subscribe( _ => this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt)
      );
  }

}
